import { FC, useEffect, useState } from 'react';
import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { Button, GhostButton } from 'ui/button';
import { SecondaryPageHeader } from 'ui/pageHeader';
import { RouterLink, spacing } from 'ui/theme';
import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';

import { AUA_BASE_PAGE_PATH, CONTENT } from '../constants';
import { CriteriaCreateFormProvider } from '../context/CriteriaCreateFormProvider';
import { useCreateAnonCriteria } from '../hooks/useCreateAnonCriteria';

import { AnonTrackingAnnouncements } from './Announcements/AnonUserTrackingAnnouncements';
import {
  CriteriaCreateFooterActions,
  CriteriaCreatePageContainer,
  FormSection,
  Section,
  SectionContent,
  SectionHeader,
} from './AnonymousUserTracking.styled';
import { CriteriaCreateForm } from './CriteriaCreateForm';
import CriteriaQueryBuilder from './CriteriaQueryBuilder';

const withContext = (Component: FC) => (props: any) => {
  return (
    <CriteriaCreateFormProvider>
      <AnonTrackingAnnouncements />
      <Component {...props} />
    </CriteriaCreateFormProvider>
  );
};

export const AnonCriteriaCreatePageCmp = () => {
  const navBarHeight = useNavBarHeight();
  const { handleSubmit } = useFormContext();
  const { createCriteria, hasCustomError } = useCreateAnonCriteria();
  const [searchQueryHasError, setSearchQueryHasError] = useState(false);

  useEffect(() => {
    setSearchQueryHasError(hasCustomError);
  }, [hasCustomError]);
  const {
    field: { onChange },
  } = useController({ name: 'searchQuery' });
  const onSubmit = (values: FieldValues) => {
    createCriteria({
      variables: {
        criteria: values,
      },
    });
  };

  return (
    <CriteriaCreatePageContainer navBarHeight={navBarHeight}>
      <SecondaryPageHeader
        breadcrumb={{
          content: CONTENT.createCriteriaPage.breadcrumbLabel,
          href: AUA_BASE_PAGE_PATH,
        }}
        widthStyle={spacing.PageWidthStyle.normal}
      >
        {CONTENT.createCriteriaPage.title}
      </SecondaryPageHeader>
      <SectionContent>
        <SectionHeader>{CONTENT.createCriteriaPage.criteriaHeader}</SectionHeader>
        <Section hasError={searchQueryHasError}>
          <CriteriaQueryBuilder onChange={onChange} />
        </Section>
        <SectionHeader>{CONTENT.createCriteriaPage.detailsHeader}</SectionHeader>
        <FormSection>
          <CriteriaCreateForm />
        </FormSection>
      </SectionContent>
      <CriteriaCreateFooterActions>
        <RouterLink to={AUA_BASE_PAGE_PATH}>
          <GhostButton>{CONTENT.createCriteriaPage.cancelBtnLabel}</GhostButton>
        </RouterLink>
        <Button data-test="create-criteria-page-create-button" onClick={handleSubmit(onSubmit)}>
          {CONTENT.createCriteriaPage.createBtnLabel}
        </Button>
      </CriteriaCreateFooterActions>
    </CriteriaCreatePageContainer>
  );
};
export const AnonCriteriaCreatePage = withContext(AnonCriteriaCreatePageCmp);
